export const MESSAGE_SPACING_FACTOR = {
  DEFAULT: 1,
  LARGE: 10,
};
